<template>
  <div class="accordion-item invoice-item bg-transparent border-0 mb-3">
    <div class="accordion-header" :id="'heading' + item.id">
      <button class="accordion-button flex-wrap justify-content-between gap-5 collapsed border border-2" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + item.id" aria-expanded="true" :aria-controls="'collapse' + item.id">
        <div class="d-flex flex-column">
          <h5 class="fs-6 fw-bold mb-2">{{ item.date }}</h5>
          <div class="fs-14px text-secondary d-flex align-items-center">
            <img v-if="item.method == 'visa'" src="@/assets/images/visa.svg" alt="" />
            <img v-if="item.method == 'master'" src="@/assets/images/master.svg" alt="" />
            <span>{{ item.card_number }}</span>
          </div>
        </div>
        <div class="d-flex flex-column">
          <div class="fs-14px text-secondary mb-2">الحالة</div>
          <h5 class="fs-16px">{{ item.status }}</h5>
        </div>
        <div class="d-flex flex-column">
          <div class="fs-14px text-secondary mb-2">المجموع</div>
          <h5 class="fs-16px fw-boldo">{{ item.total }}</h5>
        </div>
        <div class="text-secondary fs-6">الفاتورة</div>
      </button>
    </div>
    <div :id="'collapse' + item.id" class="accordion-collapse collapse" :aria-labelledby="'heading' + item.id" data-bs-parent="#accordionExample">
      <div class="accordion-body">...</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],
}
</script>

<style>
</style>